export const SET_PROFILE_COMPLETION_DATA = 'SET_PROFILE_COMPLETION_DATA';

export function setProfileCompletion(profileCompletionData) {
    return {
      type: SET_PROFILE_COMPLETION_DATA ,
        profileCompletionData,
    };
}
